import React from "react";

export default function Section({ title, caption, actions, children }) {
  return (
    <section className="sch-section">
      <div className={`sch-section-head${actions ? " with-actions" : ""}`}>
        <span className="sch-section-title">{title}</span>
        {caption ? (
          <span className="sch-section-caption">{caption}</span>
        ) : null}
        {actions ? <span className="sch-head-actions">{actions}</span> : null}
      </div>
      <div className="sch-section-body">{children}</div>
    </section>
  );
}
